import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Home from '@/views/Home.vue';
import About from '@/views/About.vue';
import Newsletter from '@/views/Newsletter.vue';
import Story from '@/views/Story.vue';
// import Stories from '@/views/Stories.vue';
import Work from '@/views/Work.vue';
import NotFound from '@/views/NotFound.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/about',
    name: 'about',
    component: About,
  },
  {
    path: '/newsletter',
    name: 'newsletter',
    component: Newsletter,
  },
  // {
  //   path: '/story',
  //   name: 'stories',
  //   component: Stories,
  // },
  {
    path: '/story/:story',
    name: 'story',
    component: Story,
  },
  {
    path: '/story/:story/:work',
    name: 'work',
    component: Work,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'catch',
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

export default router;
